import { useTranslation } from 'react-i18next';

type Props = {
    duration?: string;
};

/**
 *    LABEL DURATION
 *    ==============
 *
 *    Turn "0000-02-00" into "2 months"
 *
 * Props
 *
 *         * string duration: 0000-01-00 00:00:00
 */
export function SttLabelDuration({
    duration,
}: Props): React.ReactElement | null {
    const { t } = useTranslation();

    // Render
    return duration ? (
        <>{t(duration.length < 11 ? `${duration} 00:00:00` : duration)}</>
    ) : null;
}
